import { useEffect, useState, forwardRef } from "react";
import { CoachMark, ICoachProps } from "react-coach-mark";
import controls from '../../images/Controls.svg';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

export const UserGuide = forwardRef(({ setShowCoachMark, infoContinue, experienceStart }: any, ref: any) => {
  const { ref1, ref2, ref3, ref4, ref5 } = ref;
  const [rerender, setRerender] = useState<number>(0);
  const [activatedNumber, setActivateNumber] = useState<number>(0);

  const handleSkipAndStart = () => {
    setActivateNumber(0);
    setShowCoachMark(false);
    if (infoContinue) {
      experienceStart();
    }
  }

  const PrevArrow = <button className="prevArrow" onClick={() => setActivateNumber(activatedNumber - 1)}><ChevronLeftIcon /></button>;
  const NextArrow = <button className="nextArrow" onClick={() => setActivateNumber(activatedNumber + 1)}><ChevronRightIcon /></button>;
  const SkipLink = <div className="skipLink"><button className="skip" onClick={handleSkipAndStart} >{infoContinue ? "Skip & Start" : "Continue"}</button></div>;
  const NextButton = <div className="buttonContainer" style={{ flexDirection: 'column' }}><div style={{ display: 'flex' }} >{PrevArrow}<button className="nextBtn" onClick={() => setActivateNumber(activatedNumber + 1)}>Next ({activatedNumber + 1}/5)</button>{NextArrow}</div>{SkipLink}</div>;
  const StartButton = <div className="buttonContainer"><button className="startBtn" onClick={handleSkipAndStart}>{infoContinue ? "Start" : "Continue"}</button></div>;

  useEffect(() => { /* needed so that ref gets updates value to be passed as prop */
    setRerender(rerender + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref1.current]);

  const coachList: Array<ICoachProps> = [
    {
      activate: activatedNumber === 0,
      component: <div className="message1">Switch between locations {NextButton} </div>,
      reference: ref1,
      tooltip: { position: 'bottom' }
    },
    {
      activate: activatedNumber === 1,
      component: <div className="message2">Manage sound permission throughout the game {NextButton}</div>,
      reference: ref2,
      tooltip: { position: 'left' }
    },
    {
      activate: activatedNumber === 2,
      component: <div className="message2">View information about the experience {NextButton}</div>,
      reference: ref3,
      tooltip: { position: 'left' }
    },
    {
      activate: activatedNumber === 3,
      component: <div className="message2">Exit VR frame anytime {NextButton}</div>,
      reference: ref4,
      tooltip: { position: 'left' }
    },
    {
      activate: activatedNumber === 4,
      component: <div className="message"><img src={controls} alt="controls" width="270" height="175" /><div>Use arrow keys in your keyboard to navigate within the frame </div>{StartButton}</div>,
      reference: ref5,
      tooltip: { position: 'right' }
    }
  ]
  const coach = coachList[activatedNumber];
  return (
    <CoachMark {...coach} />
  )
})